// Nomad-mon Go! — SC3 Phase 4 (a): HAPTICS. navigator.vibrate patterns on the
// game's physical beats (pack tear, rare+ reveals tier-scaled, big hits, the
// gastro rumble, KO, victory). Settings toggle (default ON where supported);
// every call no-ops silently on unsupported platforms (iOS Safari).

const KEY = 'nomadmon-haptics';

export function supported() {
  return typeof navigator !== 'undefined' && 'vibrate' in navigator;
}
export function enabled() {
  try { return localStorage.getItem(KEY) !== '0'; } catch { return true; }
}
export function setEnabled(on) {
  try { localStorage.setItem(KEY, on ? '1' : '0'); } catch { /* private mode */ }
  if (!on && supported()) navigator.vibrate(0);
}

export function buzz(pattern) {
  if (!supported() || !enabled()) return;
  try { navigator.vibrate(pattern); } catch { /* some webviews throw */ }
}

// one short tick — the press-hold command tip. battle.js has called this since
// the tip shipped; it never existed, so every tip threw a TypeError after showing.
export function tap() { buzz(12); }

// tier-scaled reveal patterns: commons stay silent, mythics thunder
const REVEAL = {
  rare: [24],
  epic: [22, 60, 40],
  legendary: [24, 50, 40, 50, 80],
  mythic: [30, 40, 50, 40, 80, 60, 130],
  eternal: [30, 40, 50, 40, 80, 60, 130, 70, 180],
};

export const PATTERNS = {
  tear: [28, 40, 55],
  gastro: [50, 60, 50, 60, 130, 80, 220, 90, 320],   // the long rumble
  ko: [85, 60, 45],
  victory: [40, 70, 40, 70, 130],
  slotStop: [70, 40, 70],
  slotJackpot: [80, 45, 100, 55, 160, 70, 360],
};

// SC18 GOD PULL: the ceiling of the whole vibration vocabulary. Three rising
// strikes into one sustained roll — deliberately longer and heavier than the
// mythic reveal or the gastro rumble, because nothing else in the game is
// allowed to feel like this.
export function godPull() {
  buzz([40, 50, 60, 50, 90, 60, 140, 70, 240, 80, 400]);
}

export function reveal(rarity, holo = false) {
  const p = REVEAL[rarity];
  if (p) buzz(holo ? [...p, 60, 90] : p);
}

export function hit(dmg) {
  if (dmg >= 45) buzz([70, 40, 35]);
  else if (dmg >= 20) buzz([Math.min(18 + dmg, 60)]);
}
